const selectDeviceMarkerTypes = state => state.data.deviceMarkerTypes

const DeviceMarkerTypeDataStoreSelectors = {
  deviceMarkerTypes: selectDeviceMarkerTypes
}

export default DeviceMarkerTypeDataStoreSelectors
